import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Flex } from '@rebass/grid';
import get from 'lodash/get';
import { prop } from 'styled-tools';
import { ErrorMessage, Formik } from 'formik';
import * as Yup from 'yup';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { areas, bothSchools, primarySchools, secondarySchools } from '../../../constants/school_list';
import Button from '../../atoms/Button';
import Image from '../../atoms/Image';
import Input from '../../atoms/Input';
import { createChineseClothingCompetitionUser, getJoinedSchools } from '../../../api/competition';
import { withAuth } from '../../../context/auth';
import { withLoading } from '../../../context/loading';
import logoImg from '../../../assets/logo.png';
import titleImg from '../../../assets/title.png';
import registrationImg from '../../../assets/registration.png';
import checkedBox from '../../../assets/checked-checkbox.png';
import uncheckedBox from '../../../assets/unchecked-checkbox.png';
import registerButton from '../../../assets/register-button.png';
import arrow from '../../../assets/arrow.png';

const SyledRadio = (props) => {
  return <Radio
    sx={{
      padding: 0,
      marginRight: '0.5rem',
      color: '#acaead',
      '&.Mui-checked': {
        color: '#ee0c7b',
      },
    }}
    {...props}
  />
}

const Select = styled('select')`
  border: 0;
  color: #6a6a6a;
  font-size: 1rem;
  width: 100%;
  background: transparent;
  -moz-appearance: none; 
  -webkit-appearance: none; 
  appearance: none;
  background: url(${prop('arrowImage')}) no-repeat 95% 50%;
  background-size: 15px auto;
`

const FieldContainer = styled(Flex)`
  background: white;
  margin-bottom: 0.5rem;
  padding: 0.5rem;
  border-radius: 6px;
  border: 2px solid #acaead;
  box-shadow: 2px 0px 3px #acaead, -2px 0px 3px #acaead;
  color: #6a6a6a;
  align-items: center;
`

const Container = styled(Flex)`
  background: url(${prop('background')}) no-repeat center;
  background-size: 100% 100%;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 100%;
  height: 100%;
`;

const Header = styled(Flex)`
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 2rem;
  margin-bottom: 2rem;
`

const Content = styled(Flex)`
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 80%;
  height: 100%;
`;

const Error = styled(ErrorMessage)`
  color: red;
  margin-top: -0.25rem;
  margin-bottom: 0.5rem;
`;

const Counter = styled(Flex)`
  width: 100%;
`;

const SchoolList = (props) => {
  const { area, group } = props;
  let school;
  if (group === 'primary') {
    school = primarySchools
  } else if (group === 'secondary') {
    school = secondarySchools;
  } else {
    school = bothSchools;
  }
  return school[area].map((school, index) => <option value={school} key={school+index}>{school}</option>)
}

class RegisterPage extends React.Component {

  state = {
    isOther: false,
    joinedSchools: 0
  }

  componentDidMount() {
    const params = {
      $select: 'school',
      $distinct: true,
    }
    const { auth, setAuth } = this.props;
    return getJoinedSchools(params, auth, setAuth).then(obj => {
      if (obj.status === 200 && !obj.error) {
        this.setState({ joinedSchools: obj.data.length });
      }
    })
  }

  handleSelectGroup = (data, setFieldValue) => {
    setFieldValue('school', '');
    const schoolSelection = document.getElementById('school-selection');
    schoolSelection.selectedIndex = 0;
    setFieldValue('group', data);
  }

  handleSelectArea = (data, setFieldValue) => {
    setFieldValue('school', '');
    const schoolSelection = document.getElementById('school-selection');
    schoolSelection.selectedIndex = 0;
    setFieldValue('area', data);
  }

  handleSelectSchool = (data, setFieldValue) => {
    if (data === 'other') {
      setFieldValue('school', '');
      this.setState({ isOther: true });
    } else {
      setFieldValue('school', data);
      this.setState({ isOther: false });
    }
  }

  handleCreateUser = (values) => {
    const { auth, setAuth } = this.props;
    const body = {
      username: values.email,
      email: values.email,
      group: values.group,
      area: values.area,
      school: values.school,
    }
    return createChineseClothingCompetitionUser(body, auth, setAuth)
      .then(() => {
        alert('成功登記');
        window.location.reload();
      })
      .catch(err => {
        const errorResponse = get(err, 'response');
        const errorMessage = get(errorResponse, ['data', 'error'], '');
        if (errorMessage) {
          alert(errorMessage);
        }
      })
  }

  validateSchoolList = () => {
    const schoolSelection = document.getElementById('school-selection');
    const optionLength = schoolSelection.options.length;
    if (optionLength < 2) {
      alert('請先輸入學校類別和地區');
    }
  }
  
  render() {
    const { isOther, joinedSchools } = this.state;
    const initialValues = {
      email: '',
      group: '',
      area: '',
      school: '',
      agreeTerms: false
    }
    const SignupSchema = Yup.object().shape({
      email: Yup.string().email('請輸入正確的電子郵箱').required('請輸入電子郵箱'),
      group: Yup.string().required('請輸入學校類別'),
      area: Yup.string().required('請輸入地區'),
      school: Yup.string().required('請輸入學校名稱'),
      agreeTerms: Yup.boolean().oneOf([true], '提交申請前需同意本活動隱私聲明及條款'),
    });
    return (
      <Container>
        <Header>
          <Image id="logo" src={logoImg} width={100} />
        </Header>
        <Content flex={1}>
          <Image src={titleImg} width="100%" style={{ marginBottom: '1rem' }} />
          <Image src={registrationImg} width="60%" style={{ marginBottom: '1rem' }} />
          <Formik
            initialValues={{...initialValues}}
            validationSchema={SignupSchema}
            onSubmit={(values, actions) => {
              this.handleCreateUser(values);
            }}>
            {props => (
              <form id="registrationForm" onSubmit={props.handleSubmit} style={{ width: '100%'}} >
                <Flex flexDirection="column">
                  <FieldContainer>
                    <Input
                      type="email"
                      onChange={props.handleChange}
                      onBlur={props.handleBlur}
                      value={props.values.email}
                      placeholder="電子郵箱"
                      name="email"
                    />
                  </FieldContainer>
                  <Error component="div" name="email" />
                </Flex>
                <Flex flexDirection="column">
                  <Flex flex={1}>
                    <RadioGroup id="radioGroup" defaultValue="" name="radio-buttons-group" style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between'}}>
                      <FieldContainer flex={1}>
                        <SyledRadio
                          value="primary"
                          onChange={() => this.handleSelectGroup('primary', props.setFieldValue)}
                        />
                        小學
                      </FieldContainer>
                      <FieldContainer flex={1}>
                        <SyledRadio
                          value="secondary"
                          onChange={() => this.handleSelectGroup('secondary', props.setFieldValue)}
                        />
                        中學
                      </FieldContainer>
                      <FieldContainer flex={1.7}>
                        <SyledRadio
                          value="both"
                          onChange={() => this.handleSelectGroup('both', props.setFieldValue)}
                        />
                        小學&中學
                      </FieldContainer>
                    </RadioGroup>
                  </Flex>
                  <Error component="div" name="group" />
                </Flex>
                <Flex flexDirection="column">
                  <Flex justifyContent="space-between">
                    <FieldContainer flex={2}>
                      <Select
                        arrowImage={arrow}
                        defaultValue="地區"
                        onChange={(e) => this.handleSelectArea(e.target.value, props.setFieldValue)}
                      >
                          <option defaultValue="地區" disabled>地區</option>
                          {areas.map(area => <option value={area} key={area}>{area}</option>)}
                      </Select>
                    </FieldContainer>
                    <FieldContainer flex={3}>
                      <Select
                        id="school-selection"
                        arrowImage={arrow}
                        defaultValue="學校名稱"
                        onClick={this.validateSchoolList}
                        onChange={(e) => this.handleSelectSchool(e.target.value, props.setFieldValue)}
                      >
                        <option id="default" defaultValue="學校名稱" disabled>學校名稱</option>
                        {props.values.area && props.values.group &&
                          <>
                            <SchoolList area={props.values.area} group={props.values.group} />
                            <option value="other">其他-------</option>
                          </>
                        }
                      </Select>
                    </FieldContainer>
                  </Flex>
                  <Error component="div" name="area" />
                  {!isOther && <Error component="div" name="school" />}
                </Flex>
                {isOther && <Flex flexDirection="column" color="#6a6a6a" style={{ fontWeight: 'bold'}}>
                  <Flex>
                    其他（不在上列名單的學校）
                  </Flex>
                  <Flex mt="1rem">
                    <input
                      style={{ backgroundColor: 'transparent', border: 0, borderBottom: 1, borderStyle: 'solid', width: '90%', fontSize: '1.2rem' }}
                      placeholder="請輸入學校名稱"
                      type="text"
                      onChange={props.handleChange}
                      onBlur={props.handleBlur}
                      value={props.values.school}
                      name="school"
                    />
                  </Flex>
                  {isOther && <Error component="div" name="school" style={{ fontWeight: 'normal', marginTop: '0.5rem', marginBottom: '-0.25rem'}} />}
                </Flex>}
                <Flex flexDirection="column" marginY="1rem">
                  <Flex flex={1}>
                    <Flex mr="1rem" onClick={()=>{props.setFieldValue('agreeTerms', !props.values.agreeTerms)}} style={{ cursor: 'pointer' }}>
                      <Image src={props.values.agreeTerms ? checkedBox : uncheckedBox} height={20} width={20} />
                    </Flex>
                    <Flex flexDirection="column" color="#6a6a6a">
                      <Flex fontSize="1rem" style={{ fontWeight: 'bold'}}>
                        同意接受電子郵件（圖紙會郵件發送給參賽者）  
                      </Flex>
                      <Flex fontSize="0.8rem">
                        點擊登記代表你同意本活動的隱私聲明及條款並同意接受電子郵件
                      </Flex>
                    </Flex>
                  </Flex>
                  <Error component="div" name="agreeTerms" style={{ marginTop: '0.5rem', marginBottom: '-0.5rem' }} />
                </Flex>
                <Button type="submit" style={{ padding: 0 }}>
                  <Image src={registerButton} width="100%" />
                </Button>
              </form>
            )}
          </Formik>
          {joinedSchools > 0 && <Counter>
              {joinedSchools}
          </Counter>}
        </Content>
      </Container>
    );
  }
}

RegisterPage.propTypes = {
  auth: PropTypes.object,
  setAuth: PropTypes.func,
};

RegisterPage.defaultProps = {
  auth: null,
  setAuth: () => {},
};

export default withAuth(withLoading(RegisterPage));
